import { render, staticRenderFns } from "./SubsidyCodes.vue?vue&type=template&id=38d8abb4&scoped=true"
import script from "./SubsidyCodes.vue?vue&type=script&lang=ts"
export * from "./SubsidyCodes.vue?vue&type=script&lang=ts"
import style0 from "./SubsidyCodes.vue?vue&type=style&index=0&id=38d8abb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d8abb4",
  null
  
)

export default component.exports